import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { isObject, pick } from 'lodash'

interface ExperimentSrcSet {
  sm: string
  lg: string
}

interface ExperimentProps {
  variant: string
  images: ExperimentSrcSet[] | string[]
}

interface UpsellModalState {
  parent: string
  promoCode: string
  carouselCards: string[]
  header: string
  experiment: ExperimentProps
  location: string
}

const MODAL_STATE_DEFAULTS: UpsellModalState = {
  promoCode: '',
  carouselCards: [],
  header: '',
  parent: '',
  experiment: {
    variant: '',
    images: [],
  },
  location: '',
}

const unhashProps = (val: unknown): UpsellModalState => {
  try {
    if (typeof val === 'string') {
      const data = JSON.parse(Buffer.from(val as string, 'base64').toString('utf-8'))

      if (!isObject(data)) {
        console.error('Error with hashed props passed to modal')

        return MODAL_STATE_DEFAULTS
      }

      return {
        ...MODAL_STATE_DEFAULTS,
        ...pick(data, ['header', 'promoCode', 'carouselCards', 'parent', 'experiment', 'location']),
      }
    }
  } catch (e) {
    return MODAL_STATE_DEFAULTS
  }

  return MODAL_STATE_DEFAULTS
}

export const useUpsellModalQueryState = (): UpsellModalState => {
  // The query string parsed to an object, including dynamic route parameters.
  // It will be an empty object during prerendering if the page doesn't use Server-side Rendering.
  const { query } = useRouter()
  const { props: encodedProps = '' } = query // Defaults to {}
  const [modalState, setModalState] = useState<UpsellModalState>(() => unhashProps(encodedProps))

  useEffect(() => {
    setModalState(unhashProps(encodedProps))
  }, [encodedProps])

  return modalState
}
